import * as React from "react";

export const BREAKPOINTS = {
  xs: 480, // Extra small screens (phones)
  sm: 640, // Small screens (large phones, small tablets)
  md: 768, // Medium screens (tablets)
  lg: 1024, // Large screens (desktops)
  xl: 1280, // Extra large screens (large desktops)
  xxl: 1440, // Extra extra large screens
};

export type Breakpoint = keyof typeof BREAKPOINTS;

export const useBreakpoint = (breakpoint: Breakpoint) => {
  const [isBelow, setIsBelow] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(
      `(max-width: ${BREAKPOINTS[breakpoint] - 1}px)`,
    );
    const onChange = () => {
      setIsBelow(mql.matches);
    };
    mql.addEventListener("change", onChange);
    setIsBelow(mql.matches);
    return () => mql.removeEventListener("change", onChange);
  }, [breakpoint]);

  return !!isBelow;
};

export const useBreakpoints = () => {
  const isXs = useBreakpoint("xs");
  const isSm = useBreakpoint("sm");
  const isMd = useBreakpoint("md");
  const isLg = useBreakpoint("lg");
  const isXl = useBreakpoint("xl");
  const isXxl = useBreakpoint("xxl");

  return {
    isXs,
    isSm,
    isMd,
    isLg,
    isXl,
    isXxl,
    // Convenience aliases
    isMobile: isMd, // Same as the original useIsMobile
    isSmallMobile: isXs, // For very small screens
  };
};
